import { useState } from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle, CircleDollarSign } from "lucide-react";
import { DebtInfo } from "@/hooks/admin/useMemberDebts";
import { CreateDebtDialog } from "./CreateDebtDialog";
import { SettleDebtDialog } from "./SettleDebtDialog";

interface DebtActionButtonProps {
  userId: string;
  gymId: string;
  userName?: string;
  debtInfo?: DebtInfo;
}

export const DebtActionButton = ({
  userId,
  gymId,
  userName,
  debtInfo,
}: DebtActionButtonProps) => {
  const [createOpen, setCreateOpen] = useState(false);
  const [settleOpen, setSettleOpen] = useState(false);

  if (debtInfo) {
    return (
      <>
        <Button
          variant="outline"
          size="icon"
          className="sm:px-[15px] sm:w-auto border-amber-500/50 text-amber-600 hover:bg-amber-500/10 dark:text-amber-400"
          onClick={() => setSettleOpen(true)}
          title="Cancelar deuda"
          aria-label="Cancelar deuda"
        >
          <AlertCircle className="h-4 w-4" />
        </Button>
        <SettleDebtDialog
          open={settleOpen}
          onOpenChange={setSettleOpen}
          debt={debtInfo.debt}
          userName={userName}
        />
      </>
    );
  }

  return (
    <>
      <Button
        variant="outline"
        size="icon"
        className="sm:px-[15px] sm:w-auto"
        onClick={() => setCreateOpen(true)}
        title="Crear deuda"
        aria-label="Crear deuda"
      >
        <CircleDollarSign className="h-4 w-4" />
      </Button>
      <CreateDebtDialog
        open={createOpen}
        onOpenChange={setCreateOpen}
        userId={userId}
        gymId={gymId}
        userName={userName}
      />
    </>
  );
};
